var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('SideNavigation'),_c('v-content',{class:{ tinted: _vm.$store.state.auth.loggedIn }},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('BottomNavigation'),_c('Snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }